<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SalesPartyCompaniesList from './SalesPartyCompaniesList.vue';
import SalesPartyPeopleList from './SalesPartyPeopleList.vue';

const props = defineProps({
  people: { type: Array, default: () => [] },
  companies: { type: Array, default: () => [] },
  role: { type: String, required: true },
});

const emit = defineEmits(['add', 'addRepresentative', 'edit', 'remove']);
const { t } = useI18n();
const roleSingle = computed(() =>
  props.role === 'vendedor'
    ? t('SALES_PARTIES.ROLE.VENDEDOR_SINGLE')
    : t('SALES_PARTIES.ROLE.COMPRADOR_SINGLE')
);
const progressStatus = party => {
  const percent = Number(party.progress?.percent || 0);
  if (percent === 100) return t('SALES_PARTIES.LIST.STATUS_COMPLETE');
  return t('SALES_PARTIES.LIST.STATUS_DOING');
};
</script>

<template>
  <div class="grid gap-6" :aria-label="t('SALES_PARTIES.ARIA.PARTIES')">
    <SalesPartyPeopleList
      :people="people"
      :progress-status="progressStatus"
      :role-single="roleSingle"
      @add="emit('add', 'pessoa_fisica')"
      @edit="emit('edit', $event)"
      @remove="emit('remove', $event)"
    />
    <SalesPartyCompaniesList
      :companies="companies"
      :progress-status="progressStatus"
      @add-representative="emit('addRepresentative', $event)"
      @edit="emit('edit', $event)"
      @remove="emit('remove', $event)"
    />

    <div
      v-if="!people.length && !companies.length"
      class="rounded-lais border border-dashed border-lais-border bg-white p-8 text-center text-sm text-lais-text-muted"
    >
      {{ t('SALES_PARTIES.LIST.EMPTY') }}
    </div>
  </div>
</template>
